import { BoxV2 as Box } from 'portal-commons';
import React, { FunctionComponent } from 'react';

interface CampaignDescriptionProps {
  description: string;
  messageFlow: string;
  privacyPolicyLink?: string;
  termsAndConditionsLink?: string;
}

const Container: FunctionComponent = ({ children, ...props }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: '226px 2fr 226px 1fr',
      rowGap: '12px',
      fontSize: '14px',
      lineHeight: '16px',
    }}
    {...props}
  >
    {children}
  </Box>
);

const Group: FunctionComponent = ({ children, ...props }) => (
  <Box sx={{ display: 'contents' }} {...props}>
    {children}
  </Box>
);

const Label: FunctionComponent = ({ children, ...props }) => (
  <Box sx={{ fontWeight: 400 }} {...props}>
    {children}
  </Box>
);

const Value: FunctionComponent = ({ children, ...props }) => (
  <Box sx={{ fontWeight: 500 }} {...props}>
    {children}
  </Box>
);

const CampaignDescription: FunctionComponent<CampaignDescriptionProps> = ({
  description,
  messageFlow,
  privacyPolicyLink,
  termsAndConditionsLink,
}) => {
  return (
    <Container>
      <Group data-testid="campaignDescription">
        <Label>Campaign Description:</Label>
        <Value>{description}</Value>
      </Group>

      <Group data-testid="campaignPrivacyPolicyLink">
        <Label>Privacy Policy Link:</Label>
        <Value>{privacyPolicyLink || 'N/A'}</Value>
      </Group>

      <Group data-testid="campaignCallToAction">
        <Label>Call-to-Action / Message Flow:</Label>
        <Value>{messageFlow}</Value>
      </Group>

      <Group data-testid="termsAndConditionsLink">
        <Label>Terms and Conditions Link:</Label>
        <Value>{termsAndConditionsLink || 'N/A'}</Value>
      </Group>
    </Container>
  );
};

export default CampaignDescription;
